import React, { useState, useEffect, useContext } from "react";
import { Table, Button, Spin } from "antd";
import axios from "axios";
import * as XLSX from "xlsx";
import { AuthContext } from "../../context/AuthContext";
import { DownloadOutlined } from "@ant-design/icons";

export default function LeaveUtilizationReport() {
    const { authData, backUrl } = useContext(AuthContext);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [organizations, setOrganizations] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);

    const [organisationId, setOrganisationId] = useState("");
    const [departmentId, setDepartmentId] = useState("");
    const [designationId, setDesignationId] = useState("");

    // Fetch organisations
    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results);
        } catch (err) {
            console.error("Org fetch error:", err);
        }
    };

    // Fetch departments
    const fetchDepartments = async (oid) => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/departments/?organisation=${oid}`
            );
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Department fetch error:", err);
        }
    };

    // Fetch designations
    const fetchDesignations = async (depId) => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/designations/?department=${depId}`
            );
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Designation fetch error:", err);
        }
    };

    // Fetch report data
    const fetchData = async () => {

        setLoading(true);
        try {
            const res = await axios.get(
                `${backUrl}/api/reports/leave-utilization/?organisation_id=${organisationId}&department=${departmentId}&designation=${designationId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );
            setData(res.data);
        } catch (err) {
            console.error("Fetch data error:", err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchOrganizations();
        fetchData()
    }, []);

    // Excel Download
    const exportExcel = () => {
        const exportData = data.map((item) => ({
            Employee: item.employee,
            Total_Eligible: item.total_eligible,
            Total_Availed: item.total_availed,
            Balance: item.balance,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Leave Utilization");
        XLSX.writeFile(wb, "LeaveUtilizationReport.xlsx");
    };

    const columns = [
        { title: "Employee", dataIndex: "employee", width: 200 },
        { title: "Total Eligible", dataIndex: "total_eligible", width: 150 },
        { title: "Total Availed", dataIndex: "total_availed", width: 150 },
        { title: "Balance", dataIndex: "balance", width: 150 },
    ];

    return (
        <>
            <center>
                <h5>Leave Utilization Report</h5>
            </center>
            <br />

            {/* Filters */}
            <div style={{ display: "flex", gap: 15, marginBottom: 20 }}>

                {/* Organisation */}
                <select
                    className="form-control"
                    style={{ width: 200 }}
                    value={organisationId}
                    onChange={(e) => {
                        const oid = e.target.value;
                        setOrganisationId(oid);
                        setDepartmentId("");
                        setDesignationId("");
                        fetchDepartments(oid);
                    }}
                >
                    <option value="">Select Organisation</option>
                    {organizations.map((o) => (
                        <option key={o.id} value={o.id}>{o.name}</option>
                    ))}
                </select>

                {/* Department */}
                <select
                    className="form-control"
                    style={{ width: 200 }}
                    value={departmentId}
                    disabled={!organisationId}
                    onChange={(e) => {
                        const d = e.target.value;
                        setDepartmentId(d);
                        setDesignationId("");
                        fetchDesignations(d);
                    }}
                >
                    <option value="">Select Department</option>
                    {departments.map((d) => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                    ))}
                </select>

                {/* Designation */}
                <select
                    className="form-control"
                    style={{ width: 200 }}
                    value={designationId}
                    disabled={!departmentId}
                    onChange={(e) => setDesignationId(e.target.value)}
                >
                    <option value="">Select Designation</option>
                    {designations.map((d) => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                    ))}
                </select>

                {/* Apply Filter */}
                <Button
                    type="primary"
                    onClick={fetchData}
                    style={{
                        backgroundColor: "#0e497b",
                        borderColor: "#0e497b",
                        color: "white",
                    }}
                >
                    Apply
                </Button>
            </div>

            {/* Excel Download */}
            <Button
                type="primary"
                onClick={exportExcel}
                icon={<DownloadOutlined />}
                style={{
                    marginBottom: 15,
                    backgroundColor: "#0e497b",
                    borderColor: "#0e497b",
                    color: "white",
                }}
            >
                Download Excel
            </Button>

            {/* Table */}
            {loading ? (
                <Spin size="large" />
            ) : (
                <Table
                    dataSource={data}
                    columns={columns}
                    rowKey={(row) => row.employee}
                    bordered
                    size="middle"
                    components={{
                        header: {
                            cell: (props) => (
                                <th
                                    {...props}
                                    style={{
                                        backgroundColor: "#0e497b",
                                        color: "white",
                                    }}
                                >
                                    {props.children}
                                </th>
                            ),
                        },
                    }}
                />
            )}
        </>
    );
}
